document.addEventListener('DOMContentLoaded', () => {
  const headers = Array.from(document.querySelectorAll('header[data-section-id][sticky]'));
  if (!headers.length) return;

  let lastY = window.scrollY;

  const onScroll = () => {
    const y = window.scrollY;
    const direction = y > lastY ? 'down' : y < lastY ? 'up' : 'none';
    lastY = y;

    headers.forEach((header) => {
      const mode = header.getAttribute('sticky');
      if (!mode || mode === 'never') return;

      header.dataset.scrollDirection = direction;

      if (mode === 'scroll-up') {
        if (direction === 'down' && y > 80) {
          header.classList.add('header--hidden');
        } else if (direction === 'up') {
          header.classList.remove('header--hidden');
        }
      }
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  initSlidingBorder();
});

// active link slider indicator
function initSlidingBorder() {
  const menuNav = document.querySelector('.header-menu__nav');
  if (!menuNav) return;

  const menuList = menuNav.querySelector('.header-menu__list');
  const menuLinks = Array.from(menuList.querySelectorAll('.header-menu__link'));

  const indicator = document.createElement('div');
  indicator.className = 'header-menu__active-indicator';
  indicator.style.opacity = '0';
  menuList.appendChild(indicator);

  function updateIndicator(link, animate = false) {
    if (!link) {
      indicator.style.opacity = '0';
      return;
    }

    const linkRect = link.getBoundingClientRect();
    const listRect = menuList.getBoundingClientRect();
    const leftOffset = linkRect.left - listRect.left;

    if (animate) {
      indicator.classList.add('header-menu__active-indicator--animating');
    }

    indicator.style.opacity = '1';
    indicator.style.left = `${leftOffset}px`;
    indicator.style.width = `${linkRect.width}px`;

    if (animate) {
      setTimeout(() => {
        indicator.classList.remove('header-menu__active-indicator--animating');
      }, 250);
    }
  }

  const activeLink = menuLinks.find(link => link.classList.contains('header-menu__link--active'));
  if (activeLink) {
    indicator.style.transition = 'none';
    updateIndicator(activeLink);
    requestAnimationFrame(() => {
      indicator.style.transition = '';
    });
  }

  menuLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const clickedLink = e.currentTarget;
      const currentActive = menuLinks.find(l => l.classList.contains('header-menu__link--active'));

      if (currentActive && currentActive !== clickedLink) {
        e.preventDefault();

        const currentRect = currentActive.getBoundingClientRect();
        const clickedRect = clickedLink.getBoundingClientRect();
        const listRect = menuList.getBoundingClientRect();

        const startLeft = currentRect.left - listRect.left;
        const endLeft = clickedRect.left - listRect.left;
        const startWidth = currentRect.width;
        const endWidth = clickedRect.width;

        const distance = Math.abs(endLeft - startLeft);
        const direction = endLeft > startLeft ? 1 : -1;

        const expansionFactor = 1.2;
        const maxWidth = Math.max(startWidth, endWidth) * expansionFactor;

        indicator.classList.add('header-menu__active-indicator--animating');

        const animation = indicator.animate([
          {
            left: `${startLeft}px`,
            width: `${startWidth}px`
          },
          {
            left: `${startLeft + (direction * distance * 0.4)}px`,
            width: `${maxWidth}px`,
            offset: 0.4
          },
          {
            left: `${endLeft}px`,
            width: `${endWidth}px`
          }
        ], {
          duration: 250,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          fill: 'forwards'
        });

        animation.onfinish = () => {
          indicator.classList.remove('header-menu__active-indicator--animating');
          currentActive.classList.remove('header-menu__link--active');
          clickedLink.classList.add('header-menu__link--active');

          indicator.style.left = `${endLeft}px`;
          indicator.style.width = `${endWidth}px`;

          window.location.href = clickedLink.href;
        };
      }
    });
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const currentActive = menuLinks.find(l => l.classList.contains('header-menu__link--active'));
      if (currentActive) {
        updateIndicator(currentActive, false);
      }
    }, 100);
  });
}
